import React from 'react'
import { cn } from '@/lib/utils'
import { CircleNotch } from '@phosphor-icons/react'
import { TextShimmer } from '@/components/ui/TextShimmer'

interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg'
  text?: string
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-8 w-8',
}

const LoadingSpinner = React.forwardRef<HTMLDivElement, LoadingSpinnerProps>(
  ({ className, size = 'md', text, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('flex flex-col items-center justify-center gap-3', className)}
        {...props}
      >
        <div className="relative">
          <CircleNotch className={cn('animate-spin text-[#5e6ad2]/80 dark:text-[#a5b4fc]/80', sizeClasses[size])} />
          {size === 'lg' && (
            <div className="absolute inset-0 animate-ping">
              <CircleNotch className={cn('text-[#5e6ad2]/15 dark:text-[#a5b4fc]/15', sizeClasses[size])} />
            </div>
          )}
        </div>
        {text && <TextShimmer as="p" className="text-sm">{text}</TextShimmer>}
      </div>
    )
  }
)
LoadingSpinner.displayName = 'LoadingSpinner'

export const PageLoader = ({ text = 'Loading...' }: { text?: string }) => (
  <div className="flex items-center justify-center min-h-[400px] w-full">
    <LoadingSpinner size="lg" text={text} />
  </div>
)

export { LoadingSpinner }
